export const FETCH_BRAND_LEADS_EXPORTS_START = 'FETCH_BRAND_LEADS_EXPORTS_START'
export const FETCH_BRAND_LEADS_EXPORTS_SUCCESS = 'FETCH_BRAND_LEADS_EXPORTS_SUCCESS'
export const FETCH_BRAND_LEADS_EXPORTS_FAILURE = 'FETCH_BRAND_LEADS_EXPORTS_FAILURE'

export const CREATE_BRAND_LEADS_EXPORT_START = 'CREATE_BRAND_LEADS_EXPORT_START'
export const CREATE_BRAND_LEADS_EXPORT_SUCCESS = 'CREATE_BRAND_LEADS_EXPORT_SUCCESS'
export const CREATE_BRAND_LEADS_EXPORT_FAILURE = 'CREATE_BRAND_LEADS_EXPORT_FAILURE'
export const RESET_BRAND_LEADS_EXPORT_CREATE = 'RESET_BRAND_LEADS_EXPORT_CREATE'
